import { Typography } from '@mui/material';
import { StyledPaper, Title, Paragraph } from 'components/layouts/SharedStyles';

export function PaymentExplanation() {
  return (
    <StyledPaper>
      <Title>Sliding Scale Explanation</Title>
      <Typography>$100 (standard fee)</Typography>
      <Typography>$120 (a nice donation)</Typography>
      <Typography>$150 (a generous donation &ndash; support a scholarship recipient)</Typography>
      <Paragraph>If you requested a scholarship, just leave it at $100, select "pay by check" at checkout, and we will be in touch with you.</Paragraph>
    </StyledPaper>
  );
};
